import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ICustomSelectOption } from '../modals/interface/custom-select.interface'

@Component({
    selector: 'app-custom-select',
    templateUrl: './custom-select.component.html',
    styleUrls: ['./custom-select.component.scss'],
    standalone: false
})
export class CustomSelectComponent implements OnInit {
  public finalOptions: ICustomSelectOption[]
  public selectedValue?: string

  @Input() title: string
  @Input() placeHolder?: string
  @Input() clearable?: boolean
  @Input() options: ICustomSelectOption[]
  @Input() selectValueByDefault?: boolean
  @Input() translate = true

  @Output() changeValue: EventEmitter<string> = new EventEmitter()

  ngOnInit(): void {
    this.finalOptions = this.options
    if (this.selectValueByDefault) {
      this.selectedValue = this.finalOptions[0].value
    }
  }
}
